import clsx from "clsx";
import { Controller, useFormContext } from "react-hook-form";
import S from "./index.module.scss";
import { FormFieldType } from "./types";
import { FC } from "react";

interface IFormFieldProps {
  field: FormFieldType;
}

const FormField: FC<IFormFieldProps> = ({ field }) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={field.id}
      render={({ field: controlledField, fieldState }) => {
        const message = fieldState.error?.message;
        const withError = Boolean(message);
        const errorId = withError ? `${field.id}-error` : undefined;

        return (
          <div className={S.field}>
            <label className={S.label} htmlFor={field.id}>
              {field.label}
            </label>
            {field.multiline ? (
              <textarea
                id={field.id}
                required={field.required}
                placeholder={field.placeholder}
                autoComplete={field.autoComplete}
                aria-invalid={withError}
                aria-describedby={errorId}
                className={clsx(S.textarea, withError && S.inputError)}
                {...controlledField}
              />
            ) : (
              <input
                id={field.id}
                type={field.type}
                required={field.required}
                placeholder={field.placeholder}
                autoComplete={field.autoComplete}
                aria-invalid={withError}
                aria-describedby={errorId}
                className={clsx(S.input, withError && S.inputError)}
                {...controlledField}
              />
            )}
            {withError ? (
              <span id={`${field.id}-error`} className={S.error}>
                {message}
              </span>
            ) : null}
          </div>
        );
      }}
    />
  );
};

export default FormField;
